import {
    FETCH_PAYMENT_METHODS,
    FETCH_PAYMENT_METHODS_SUCCESS,
    FETCH_PAYMENT_METHODS_FAILED,
    UPDATE_WALLET_BALANCE,
    UPDATE_WALLET_BALANCE_SUCCESS,
    UPDATE_WALLET_BALANCE_FAILED,
    CLEAR_PAYMENT_MESSAGES,
    UPDATE_PAYMENT_METHOD
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, get, update, push } from "firebase/database";

export const fetchPaymentMethods = () => (dispatch) => {

    const {
      paymentSettingsRef
    } = firebase;
  
    dispatch({
      type: FETCH_PAYMENT_METHODS,
      payload: null
    });

    const usertype = store.getState().auth.profile.usertype;

    // Allowed providers on this app
    const ALLOWED_PROVIDERS = ['flutterwave', 'paystack', 'opay', 'test'];

    if(usertype == 'admin'){
        onValue(paymentSettingsRef, snapshot => {
            const data = snapshot.val(); 
            if(data){
              dispatch({
                type: FETCH_PAYMENT_METHODS_SUCCESS,
                payload: data
              });
            } else {
              dispatch({
                type: FETCH_PAYMENT_METHODS_FAILED,
                payload: store.getState().languagedata.defaultLanguage.no_provider_found,
              });
            }
          });
    } else { 
        // Read directly from Firebase RTDB - no Cloud Function needed
        get(paymentSettingsRef)
            .then((snapshot) => {
                const data = snapshot.val();
                if (data) {
                    const arr = [];
                    const pms = Object.keys(data);
                    for (let i = 0; i < pms.length; i++) {
                        const key = pms[i];
                        // Only include allowed providers that are active
                        if (data[key].active && ALLOWED_PROVIDERS.includes(key)) {
                            arr.push({
                                name: key,
                                link: '/' + key + '-link'
                            });
                        }
                    }
                    if (arr.length > 0) {
                        dispatch({
                            type: FETCH_PAYMENT_METHODS_SUCCESS,
                            payload: arr,
                        });
                    } else {
                        dispatch({
                            type: FETCH_PAYMENT_METHODS_FAILED,
                            payload: store.getState().languagedata.defaultLanguage.no_provider_found,
                        });
                    }
                } else {
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_FAILED,
                        payload: store.getState().languagedata.defaultLanguage.no_provider_found,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_PAYMENT_METHODS_FAILED,
                    payload: (store.getState().languagedata.defaultLanguage.provider_fetch_error || 'Error fetching providers') + ': ' + error.toString(),
                });
            });
    }
  };

  export const editPaymentMethods = (data) => (dispatch) => {
    const {
        paymentSettingsRef
    } = firebase;
    dispatch({
      type: UPDATE_PAYMENT_METHOD,
      payload: data 
    });
    update(paymentSettingsRef, data);
  }
  


export const clearMessage = () => (dispatch) => {
    dispatch({
        type: CLEAR_PAYMENT_MESSAGES,
        payload: null,
    });    
};


export const addToWallet = (uid, amount) => async (dispatch) => {
    const {
        walletHistoryRef,
        singleUserRef,
        settingsRef
    } = firebase;

    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    try {
        const settingsdata = await get(settingsRef);
        const settings = settingsdata.val() || {};

        const userSnapshot = await get(singleUserRef(uid));
        if (userSnapshot.exists() && userSnapshot.val()) {
            const userData = userSnapshot.val();
            let currentBalance = parseFloat(userData.walletBalance || 0);
            const pushToken = userData.pushToken;
            const newBalance = parseFloat((currentBalance + parseFloat(amount)).toFixed(settings.decimal || 2));
            
            let details = {
                type: 'Credit',
                amount: parseFloat(amount),
                date: new Date().getTime(),
                txRef: 'WalletTopUp'
            };

            await update(singleUserRef(uid), { walletBalance: newBalance });
            await push(walletHistoryRef(uid), details);

            dispatch({
                type: UPDATE_WALLET_BALANCE_SUCCESS,
                payload: null
            });

            if (pushToken) {
                const defaultLanguage = store.getState().languagedata?.defaultLanguage || {};
                RequestPushMsg(
                    pushToken,
                    {
                        title: defaultLanguage.notification_title || 'Wallet Updated',
                        msg: defaultLanguage.wallet_updated || 'Your wallet balance has been updated.',
                        screen: 'Wallet'
                    }
                );
            }
        } else {
            dispatch({
                type: UPDATE_WALLET_BALANCE_FAILED,
                payload: 'User not found'
            });
        }
    } catch (error) {
        dispatch({
            type: UPDATE_WALLET_BALANCE_FAILED,
            payload: error.code ? `${error.code}: ${error.message}` : error.message
        });
    }
};


export const withdrawBalance = (profile, amount) => async (dispatch) => {

    const {
        withdrawRef,
    } = firebase;
    
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    push(withdrawRef, {
        uid : profile.uid,
        name : profile.firstName +  ' ' + profile.lastName,
        amount : parseFloat(amount),
        date : new Date().getTime(),
        bankName : profile.bankName? profile.bankName : '',
        bankCode : profile.bankCode? profile.bankCode : '',
        bankAccount : profile.bankAccount? profile.bankAccount : '',
        processed:false
    });
       
};
